//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQCheckbox from "@/components/Generics/AQCheckbox/AQCheckbox.vue";

const checkTimeFormat = value => {
    const regex = /^(?:\d+[d](?: {1}|$))?(?:\d+[h](?: {1}|$))?(?:\d+[m](?: {1}|$))?$/;
    return value ? regex.test(value) : !value;
};
const checkIfNumber = value => Number.isInteger(value);
export default {
    components: {
        AQInput,
        AQChip,
        AQDropdown,
        AQCheckbox
    },
    props: {
        value: {
            type: Object
        },
        readonly: {
            type: Boolean
        },
        setOptions: {
            type: [Object, Array]
        },
        optionSelected: {
            type: String
        },
        optionSchedule: {
            type: Boolean
        },
        isRuleModal: {
            type: Boolean
        }
    },
    data() {
        return {
            error: false,
            creationDateTimeField: this.$t("diagrams.components.deadlineExpiration.defaultCreation"),
            defaultCreationDateChip: "Task",
            timeToExpiration: this.value ? this.calcExtraTime(this.value) : "",
            expirationErrorMsg: "",
            expirationNotConfigured: false,
            expirationTargetData: "",
            optionsBehaviour: [
                {
                    label: this.$t("diagrams.components.ifExpires.autoReject"),
                    value: "AR",
                    leftIcon: { name: "lens", size: "16px", color: "#D15656" }
                },
                {
                    label: this.$t("diagrams.components.ifExpires.autoApprove"),
                    value: "AA",
                    leftIcon: { name: "lens", size: "16px", color: "#63D471" }
                }
            ],
            days: 0,
            hours: 0,
            minutes: 0,
            defaultValue: "AR",
            defaultLabel: "",
            useWorkingSchedule: false,
            workScheduleExists: false
        };
    },
    validations() {
        return this.setValidations;
    },
    computed: {
        getApprovalErrorLabel() {
            let errorMsg = this.$t("diagrams.components.onlyNumeric");
            if (this.$v.currentApprovalTimeValue && !this.$v.currentApprovalTimeValue.required) {
                errorMsg = this.$t("errorRequired");
            }
            return errorMsg;
        },
        setValidations() {
            let defaultValidations = {};
            defaultValidations = { timeToExpiration: { required, checkTimeFormat }, expirationTargetData: { required } };
            return defaultValidations;
        },
        checkExpirationError() {
            return this.setErrorMsg("timeToExpiration", "expiration");
        },
        getTargetProps() {
            return {
                label: this.$t("diagrams.components.setLevels.selectBehaviour"),
                options: this.optionsBehaviour,
                defaultValue: this.defaultValue,
                avatarRounded: false
            };
        },
        showPrimaryExpDesc() {
            return this.timeToExpiration && this.$v.timeToExpiration && !this.$v.timeToExpiration.$error;
        }
    },
    watch: {
        setOptions: {
            handler(value) {
                if (value.index !== 0) {
                    this.optionsBehaviour.push({
                        label: this.$t("diagrams.components.ifExpires.propagatePreviousDecision"),
                        value: "PPD",
                        leftIcon: { name: "lens", size: "16px", color: "#F2BD46" }
                    });
                }
            },
            immediate: true
        },
        timeToExpiration: {
            handler() {
                let days = null; let hours = null; let
                    minutes = null;
                const splitedData = this.timeToExpiration.split(" ");
                splitedData.forEach(element => {
                    if (element.includes("d")) {
                        days = parseInt(element.split("d")[0], 10);
                    } else if (element.includes("h")) {
                        hours = parseInt(element.split("h")[0], 10);
                    } else if (element.includes("m")) {
                        minutes = parseInt(element.split("m")[0], 10);
                    }
                });
                this.$emit("input", { days, hours, minutes });
            }
        },
        value: {
            handler(v) {
                if (v) {
                    if (v.approvalTime || v.timeUnit) {
                        if (v.approvalTime === "0") {
                            this.timeToExpiration = `0${v.timeUnit.substring(0, 1)}`;
                        } else {
                            this.setOldTimeFormat(v.approvalTime || 0, v.timeUnit, "timeToExpiration");
                        }
                    } else if (!v.days && !v.hours && v.minutes) {
                        if (parseInt(v.minutes, 10) === 0) {
                            this.timeToExpiration = "0m";
                        } else {
                            this.setOldTimeFormat(parseInt(v.minutes, 10), "minutes", "timeToExpiration");
                        }
                    }
                }
            },
            immediate: true
        },
        optionSelected: {
            handler(value) {
                this.defaultValue = value;
                const option = this.optionsBehaviour.find(element => element.value === value);
                this.defaultLabel = option.label;
            },
            immediate: true
        },
        useWorkingSchedule: {
            handler(value) {
                this.$emit("workScheduleInfo", value);
            }
        }
    },
    created() {
        this.getWorkingSchedule().then(response => {
            this.workScheduleExists = response.data;
        });
        this.useWorkingSchedule = !!this.optionSchedule;
    },
    methods: {
        ...mapActions("diagrams", ["getWorkingSchedule"]),
        setErrorMsg(field, typeExpiration) {
            let msg = this.$t(`diagrams.components.deadlineExpiration.${typeExpiration ? "expirationError" : ""}`);
            if (this.$v[field] && !this.$v[field].checkTimeFormat) {
                msg = this.$t("diagrams.components.deadlineExpiration.deadlineFormat");
            }
            if (typeExpiration) {
                this.expirationErrorMsg = msg;
            }
            return this.$v[field].$error;
        },
        changeTimeToExpiration() {
            if (this.$v.timeToExpiration) {
                this.$v.timeToExpiration.$touch();
            }
            this.checkTimeFormatValue("timeToExpiration");
        },
        checkTimeFormatValue(type) {
            setTimeout(() => {
                this.checkCalcExtraTime(type);
            }, 0);
        },
        checkCalcExtraTime(type) {
            if (this.$v[type] && this.$v[type].checkTimeFormat) {
                const data = type === "timeToExpiration" ? this.getDeadlineData(null, "expiration") : this.getDeadlineData();
                if (data.days || data.hours || data.minutes) {
                    this[type] = this.calcExtraTime(data);
                }
            }
        },
        setOldTimeFormat(data, timeUnit, type) {
            const newFormatData = { days: null, hours: null, minutes: null };
            newFormatData[timeUnit] = parseInt(data, 10);
            this[type] = this.calcExtraTime(newFormatData);
        },
        setValidTime(value) {
            if (value) {
                if (!checkIfNumber(value)) {
                    value = parseInt(value, 10);
                }
            } else {
                value = 0;
            }
            return value;
        },
        calcExtraTime(data) {
            let extraHours = 0; let
                extraDays = 0;
            const approvalData = data;

            approvalData.minutes = this.setValidTime(approvalData.minutes);
            approvalData.hours = this.setValidTime(approvalData.hours);
            approvalData.days = this.setValidTime(approvalData.days);

            if (approvalData.minutes && approvalData.minutes > 59) {
                let dataMinutes = 0; let
                    remainingMinutes = 0;

                dataMinutes = approvalData.minutes / 60;
                extraHours = Math.floor(dataMinutes);
                remainingMinutes = extraHours > 0 ? approvalData.minutes - (extraHours * 60) : 0;
                if (remainingMinutes > 0) {
                    approvalData.minutes = remainingMinutes;
                } else {
                    approvalData.minutes = 0;
                }
            }

            if (approvalData.hours + extraHours > 23) {
                let dataHours = 0; let
                    remainingHours = 0;
                approvalData.hours += extraHours;
                dataHours = approvalData.hours / 24;
                extraDays = Math.floor(dataHours);
                remainingHours = extraDays > 0 ? approvalData.hours - (extraDays * 24) : 0;
                if (remainingHours > 0) {
                    approvalData.hours = remainingHours;
                } else {
                    approvalData.hours = 0;
                }
            } else if (extraHours) {
                approvalData.hours += extraHours;
            }
            if (extraDays) {
                approvalData.days += extraDays;
            }
            return this.setNewTimeFormat(approvalData);
        },
        setNewTimeFormat(data) {
            let newFormat = "";
            const days = ((data.days && parseInt(data.days, 10)) || data.days === 0) ? `${data.days}d` : "";
            const hours = ((data.hours && parseInt(data.hours, 10)) || data.hours === 0) ? `${data.hours}h` : "";
            const minutes = ((data.minutes && parseInt(data.minutes, 10)) || data.minutes === 0) ? `${data.minutes}m` : "";

            newFormat = days + (days && hours ? ` ${hours}` : hours) + (((days || hours) && minutes) ? ` ${minutes}` : minutes);
            return newFormat;
        },
        getDeadlineData(add, type, expirationOnly, generalDescrip) {
            let items = ""; let days = add ? "" : 0; let hours = add ? "" : 0; let minutes = add ? "" : 0;
            const splitedData = (type || expirationOnly ? this.timeToExpiration : this.timeToDeadline).split(" ");
            splitedData.forEach(element => {
                if (element.includes("d")) {
                    days = this.getDescriptInfo(element, "d", add);
                } else if (element.includes("h")) {
                    hours = this.getDescriptInfo(element, "h", add);
                } else if (element.includes("m")) {
                    minutes = this.getDescriptInfo(element, "m", add);
                }
            });
            if (add) {
                const validDays = days || checkIfNumber(days);
                const validHours = hours || checkIfNumber(hours);
                const validMinutes = minutes || checkIfNumber(minutes);
                if (validDays || validHours || validMinutes) {
                    this.checkSetNoConfig(type, expirationOnly, true);
                    const getCustomHours = () => (days ? ` ${hours}` : hours);
                    const getCustomMinutes = () => ((days || hours) ? ` ${minutes}` : minutes);
                    const customTime = (days || "") + (hours ? getCustomHours() : "") + (minutes ? getCustomMinutes() : "");
                    const getCustomDesc = () => (generalDescrip ? "descriptionGen" : "description");
                    items = this.$t(`diagrams.components.deadlineExpiration.${type ? "descriptionExpiration1After" : getCustomDesc()}`, { customTime });
                    if (generalDescrip) {
                        items += this.$t(`diagrams.components.deadlineExpiration.${customTime ? "generalInfoDeadFrom" : "generalInfoDead"}`);
                    }
                } else {
                    this.checkSetNoConfig(type, expirationOnly);
                }
            } else {
                items = { days, hours, minutes };
            }
            return items;
        },
        checkSetNoConfig(type, expirationOnly, config) {
            if (type || expirationOnly) {
                this.expirationNotConfigured = !!config;
            }
        },
        getDescriptInfo(element, condition, add) {
            const itemNumber = parseInt(element.replace(condition, ""), 10);
            let item = Number.isNaN(itemNumber) ? "" : itemNumber;
            if (item && add) {
                item += ` ${this.$t(`diagrams.components.deadlineExpiration.${item === 1 ? condition : (`${condition}s`)}`)}`;
            }
            return item;
        },
        selectBehaviour($event) {
            this.$emit("selectedBehaviour", $event[0].value);
        }
    }
};
